export default "__VITE_ASSET__2CMco25C__"